export const ApiUrl = "https://db.ficfs.zu.edu.ly/";
// export const ApiUrl = "http://reecd.zu.edu.ly/";
// export const ApiUrl = "http://localhost:2020/";
